import 'whatwg-fetch';
import TabbedContent from "./Components/TabbedContent";
let Flickity = require('flickity');

window.onload = () => {

    // STICKY HEADER

    let siteHeader = document.querySelector('.js-sticky-header');

    if (!siteHeader) {
        return;
    }

    let lastScrollPosition = window.scrollY || window.pageYOffset;
    let ticking = false;
    let isToggled = false;

    let toggleStickyHeader = (scrollPosition) => {
        isToggled = scrollPosition > 100;
        if (isToggled) {
            siteHeader.classList.add('site-header--sticky');
        } else {
            siteHeader.classList.remove('site-header--sticky');
        }
    };

    toggleStickyHeader(lastScrollPosition);

    window.addEventListener('scroll', function (e) {
        lastScrollPosition = window.scrollY || window.pageYOffset;

        if (!ticking) {
            window.requestAnimationFrame(function () {
                toggleStickyHeader(lastScrollPosition);
                ticking = false;
            });

            ticking = true;
        }
    });

    // HAMBURGER MENU

    var menuToggleButton = document.querySelector('.js-toggle-drawer');

    let toggleDrawerMenu = e => {
        e.stopPropagation();

        let menuContainer = document.querySelector('.drawer-menu-container');

        if (!menuContainer) {
            return null;
        }

        document.body.classList.toggle('drawer-active');
        menuToggleButton.classList.toggle('is-active');
        menuContainer.classList.toggle('drawer-menu-container--active');
    };

    let initHamburgerMenu = menuToggleButton => {
        if (!menuToggleButton) {
            return;
        }

        menuToggleButton.addEventListener('click', toggleDrawerMenu);
    };

    initHamburgerMenu(menuToggleButton);

    // FLICKITY SLIDERS

    if (window.innerWidth < 600) {
        Array.from(document.querySelectorAll('.js-news-carousel')).forEach(carouselElement => {
            let carousel = new Flickity(
                carouselElement,
                {
                    // options
                    cellAlign: 'center',
                    selectedAttraction: 0.1,
                    friction: 0.5,
                    prevNextButtons: false,
                    pageDots: false,
                }
            );
        });
    }

    // MODALS

    Array.from(document.querySelectorAll('.js-trigger-modal')).forEach(modalTrigger => {
        modalTrigger.addEventListener('click', e => {
            e.preventDefault();
            let target = document.querySelector(modalTrigger.dataset.modal);
            if (target) {
                target.classList.add('modal--active');
            }
        });
    });

    Array.from(document.querySelectorAll('.modal')).forEach(modal => {
        modal.addEventListener('click', e => {
           if (modal.classList.contains('modal--active') && modal === e.target) {
               modal.classList.remove('modal--active');
           }
        });
    });

    Array.from(document.querySelectorAll('.js-trigger-focus')).forEach(focusTrigger => {
        focusTrigger.addEventListener('click', e => {
             e.preventDefault();
             let target = document.querySelector(focusTrigger.dataset.focus);
             if (target) {
                 setTimeout(() => {
                     target.focus();
                 }, 100);
             }
        });
    });

    // TABBED CONTENT

    window.tabbedContentWidgets = [];

    Array.from(document.querySelectorAll('.js-tabbed-content')).forEach(element => {
        window.tabbedContentWidgets.push(new TabbedContent(element));
    });

};
